import {Button, Col, Row} from "react-bootstrap";
import Back from "../layout/template/back";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import ApiService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";
import AppRoute from "../../utils/AppRoute";
import GenericErrorModal from "../modal/genericErrorModal";

const AdminDetailCoupon = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const [couponData, setCouponData] = useState();

    const [errorModal, setErrorModal] = useState({
        state: false,
        title: "",
        body: ""
    });

    useEffect(() => {
        let couponId = location.state?.from;

        ApiService.getCouponById(couponId).then(data => {
            setCouponData(data);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAnnullaBuono = (e) =>{
        e.preventDefault()

        ApiService.deleteCoupon(location.state?.from).then(response => {
            setErrorModal({
                state: true,
                title: "Buono Annullato",
                body: "Ok"
            })
            navigate(-1);
        })
            .catch(error => {
                setErrorModal({
                    state: true,
                    title: "Errore nell'eliminazione del buono",
                    body: "Ok"
                })
            })
    }

    const handleGoToOrder = (e) => {
        navigate(AppRoute.ADMIN_DETAIL_ORDERS, {state:{from: (couponData && couponData.basketId)}})
    }

    const handleCloseErrorModal = () => setErrorModal({
        state: false,
        title: "",
        body: ""
    })

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row className={'justify-content-between'}>
                        <Col>
                            <div className={'title-page-section mt-5 mb-5'}>
                                <h2 className={'title'}>Coupon</h2>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} lg={6}>
                    <Row className="card g-0 mb-3">
                        <Col xs={12}>
                            <div className="card-body">
                                {couponData &&
                                    <div className="card-information">
                                        <p className={'mb-0'}>Codice buono: <span className={'fw-bold'}>{couponData.code}</span></p>
                                        <p className={'mb-0'}>Valore: <span className={'fw-bold'}>{couponData.discount === 0? `${couponData.cost} CHF` : `${couponData.discount}%`}</span></p>
                                        <p className={'mb-0'}>Emesso il: <span className={'fw-bold'}>{DateTimeUtils.getEmissionDateFromExpiring(couponData.validUntil).toLocaleString()}</span></p>
                                        <p className={'mb-0'}>Usato il: <span className={'fw-bold'}>{DateTimeUtils.getEmissionDateFromExpiring(couponData.dateOfUse).toLocaleString()}</span></p>
                                        <p className={'mb-0'}>Status: <span className={'fw-bold'}>{couponData.status}</span></p>
                                    </div>

                                }
                            </div>
                        </Col>
                    </Row>
                    <Row className={'justify-content-end'}>
                        <Col xs={'auto'}>
                            <div className={'d-flex gap-2'}>
                                <Button variant={'outline-primary'}
                                        className={'mb-5 px-5 fw-bold'} disabled={couponData && couponData.basketId === null} onClick={handleGoToOrder}>Link all'ordine</Button>
                                <Button variant={'primary'} onClick={handleAnnullaBuono}
                                        className={'mb-5 px-5 fw-bold'}>Annulla buono</Button>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <GenericErrorModal handleClose={handleCloseErrorModal} contentText={errorModal} showModal={errorModal.state}/>

        </>

    );
}

export default AdminDetailCoupon;
